var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',{staticClass:"d-flex",staticStyle:{"background-color":"var(--grey3)"},attrs:{"estyle":"{\n    backgroundColor: chroma(item.color)\n      .alpha({ dark: 0.4, light: 0.3 }[$store.state.settings.theme])\n      .brighten(1)\n      .hex(),\n  }"}},[_c('b-form-checkbox',{style:({
      '--checkcolor': _vm.chroma(_vm.item.color)
        [{ dark: 'darken', light: 'brighten' }[_vm.$store.state.settings.theme]](
          2
        )
        .hex(),
      '--checkfocus': _vm.chroma(_vm.item.color).brighten(2).hex(),
      '--checkshadow': _vm.chroma(_vm.item.color).hex() + '08',
    }),attrs:{"checked":_vm.completed},on:{"input":_vm.toggleCompletion}}),_c('span',{style:({
      color: _vm.chroma(_vm.item.color)
        .desaturate(0)
        [{ dark: 'brighten', light: 'darken' }[_vm.$store.state.settings.theme]](
          2
        )
        .hex(),
    })},[_vm._v(_vm._s(_vm.item.title))]),_c('b-form-tag',{staticClass:"mx-1",style:({
      backgroundColor:
        _vm.$store.state.tags[_vm.item.type].color[_vm.$store.state.settings.theme],
    }),attrs:{"variant":"none","no-remove":""}},[_vm._v(_vm._s(_vm.$store.state.tags[_vm.item.type].name))]),_c('i',{staticClass:"ml-1",style:({
      color: _vm.chroma(_vm.item.color)
        .desaturate(3)
        .darken(1)
        [{ dark: 'brighten', light: 'darken' }[_vm.$store.state.settings.theme]]()
        .hex(),
    })},[_vm._v(_vm._s(_vm._f("moment")(_vm.item.dueDate,"from", "now")))]),_c('b-btn-close',{staticClass:"ml-auto",on:{"click":_vm.deleteItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }